// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"App_appWrapper__3Gr8-","content":"App_content__1ojR8","contentWidthLimiter":"App_contentWidthLimiter__1CFdS"};